<script setup lang="ts"></script>

<template>
  <h1 class="text-white">Profile</h1>
  <p>Page not available</p>
</template>
